export const CUSTOMER_SUPPORT_EMAIL = 'cscomments@myriad.com';
export const REACT_APP_CONTACT_US_URL = 'https://myriad.com/contact-us/';
export const REACT_APP_CONTACT_US_PHONE = '18882686795';
export const PRENATAL_PORTAL_LINK = 'https://app.counsyl.com/accounts/login/';
